export const setUser = (store, user) => {
  store.state.user = user;
  store.setState({ user });
};

export const setProfile = (store, profile) => {
  store.state.profile = profile;
  store.setState({ profile });
};
